// src/components/AddMember.jsx
import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function AddMember() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cell, setCell] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAdd = async (e) => {
    e.preventDefault();

    if (!name.trim() || !email.trim() || !cell.trim() || !address.trim()) {
      alert("Please complete all fields.");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "members"), {
        name: name.trim(),
        email: email.trim(),
        cell: cell.trim(),
        address: address.trim(),
        createdAt: serverTimestamp(),
      });

      alert("Member added!");

      // Reset fields
      setName("");
      setEmail("");
      setCell("");
      setAddress("");

    } catch (err) {
      console.error("Error adding member:", err);
      alert("Error adding member: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h2 className="text-xl font-bold mb-4">Add Member</h2>

      <form onSubmit={handleAdd} className="space-y-4">

        {/* Name */}
        <div>
          <label className="block text-sm font-medium mb-1">Full Name</label>
          <input
            type="text"
            placeholder="Enter full name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="p-2 border w-full rounded"
            required
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium mb-1">Email Address</label>
          <input
            type="email"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-2 border w-full rounded"
            required
          />
        </div>

        {/* Cell Number */}
        <div>
          <label className="block text-sm font-medium mb-1">Cell Number</label>
          <input
            type="tel"
            placeholder="e.g., 078 123 4567"
            value={cell}
            onChange={(e) => setCell(e.target.value)}
            className="p-2 border w-full rounded"
            required
          />
        </div>

        {/* Home Address */}
        <div>
          <label className="block text-sm font-medium mb-1">Home Address</label>
          <textarea
            placeholder="Enter home address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="p-2 border w-full rounded"
            rows={3}
            required
          />
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-60"
          >
            {loading ? "Saving…" : "Add Member"}
          </button>
        </div>

      </form>
    </div>
  );
}
